import styled from "styled-components";
import { Heading } from "../../common/Heading/Heading";
import { useTranslation } from "react-i18next";
import { media } from "../../../styles/mixins";
import { FullWidthSectionWithContent } from "../../common/FullWidthSectionWithContent";
import { StepOne } from "../../../assets/images/StepOne";
import { StepTwo } from "../../../assets/images/StepTwo";
import { StepThree } from "../../../assets/images/StepThree";
import { StepFour } from "../../../assets/images/StepFour";
import { COLORS } from "../../../assets/constants/styles";
import { Button } from "../../common/Button/Button";

import { openExtensionStore } from "../../../helpers/various-helpers";

export const HowToStart = ({ activeCrm }) => {
  const { t } = useTranslation();

  const stepsImages = [<StepOne />, <StepTwo />, <StepThree />, <StepFour />];

  return (
    <FullWidthSectionWithContent>
      <HowToStartContainer id="quickstart">
        <TitleContainer>
          <Heading size={1} text={t("howToStart.title")} />
          <Caption> {t("howToStart.caption")}</Caption>
        </TitleContainer>
        <StepsContainer>
          {stepsImages.map((image, index) => {
            return (
              <StepContainer key={`step-${index}`}>
                {image}
                <StepTextContainer>
                  <StepTitle>{t(`howToStart.steps.${index}.title`)}</StepTitle>
                  <StepCaption>
                    {t(`howToStart.steps.${index}.description`)}
                  </StepCaption>
                </StepTextContainer>
              </StepContainer>
            );
          })}
        </StepsContainer>
        <Button
          text={t("howToStart.installTry")}
          onClick={() => {
            openExtensionStore();
          }}
        />
      </HowToStartContainer>
    </FullWidthSectionWithContent>
  );
};

const HowToStartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 37px;
  margin-bottom: 32px;
  gap: 32px;
  text-align: center;

  ${media.tablet(`
    margin-top: 58px;
     margin-bottom: 40px;
     gap: 40px;
  `)}

  ${media.laptop(`
    margin-top: 80px;
    margin-bottom: 70px;
    gap: 64px;
  `)}
`;

const Caption = styled.div`
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: ${COLORS.grey};

  margin-top: 16px;

  ${media.tablet(`
     margin-top: 28px;
  `)}
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
`;

const StepsContainer = styled.div`
  display: grid;
  grid-gap: 16px;
  width: 100%;
  grid-template-columns: 1fr;

  ${media.tablet(`
     grid-template-columns: 1fr 1fr;
  `)}

  ${media.laptop(`
    grid-template-columns: 1fr 1fr 1fr 1fr;
 `)}
`;

const StepContainer = styled.div`
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
`;

const StepTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px 26.5px;
  height: 70px;

  ${media.laptop(`
    padding:  16px 20px;
`)};
`;

const StepTitle = styled.div`
  font-size: 16px;
  line-height: 150%;
`;

const StepCaption = styled.div`
  color: ${COLORS.lightGrey};

  font-size: 13px;
  line-height: 120%;
  letter-spacing: -0.005em;
`;
